import { fetchApi } from '@/config/axiosSetting';
import {
  GetDamagedAdjusterImagesQueryParamsType,
  GetDamagedAdjusterImagesQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterImages/getDamagedAdjusterImagesQuery.type';

export const getDamagedAdjusterImagesFunction = (
  params: GetDamagedAdjusterImagesQueryParamsType,
): Promise<GetDamagedAdjusterImagesQueryResponseType> => {
  const url = () => {
    switch (params.participantRoleType) {
      case 'damaged':
      case 'culprit':
        return `property/reports/${params?.id}/accident_users/${params?.participantRoleType}/adjuster/vehicle/`;
      case 'initial':
        return `initial/reports/${params?.id}/images/adjuster/vehicle/`;
      case 'body':
        return `body/reports/${params?.id}/images/adjuster/vehicle/`;
      default:
        return '';
    }
  };

  return fetchApi.get(url(), {
    params: {
      damaged_id: params?.damaged_id,
    },
  });
};
